import moment from 'moment';

type StudentItemLike = { endOfParticipation?: Date | string | null; resumptionOfParticipation?: Date | string | null };

/**
 * Children taking part on the day of `now` (participation not ended, or resumed again). The end of participation is the
 * last day (inclusive) – the same count as the big calendar shows for a lesson of that day.
 */
export function activeStudentCount(course: { studentItems?: StudentItemLike[] }, now: moment.MomentInput = moment()): number {
    return (course.studentItems || []).filter((item) => {
        if (!item.endOfParticipation || moment(item.endOfParticipation).isSameOrAfter(now, 'day')) {
            return true;
        }
        return !!item.resumptionOfParticipation && moment(item.resumptionOfParticipation).isSameOrBefore(now, 'day');
    }).length;
}

/** Day of this week's lesson (dayOfWeek 0 = Monday) */
export function lessonDayThisWeek(dayOfWeek: number, now: moment.MomentInput = undefined): moment.Moment {
    return moment(now).startOf('isoWeek').add(dayOfWeek, 'days');
}
